import { isHeicFile, convertHeicToJpeg } from "common/utils/heic-converter";

export const getImageInfo = async (url, options = {}) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    Object.keys(options).forEach(key => {
      image[key] = options[key];
    });
    image.onload = () => {
      const { width, height } = image;
      resolve({ width, height, ratio: width / height, image });
    };
    image.onerror = reject;
    image.src = url;
  });

export const isBlobUrl = url => {
  try {
    return new URL(url).protocol === "blob:";
  } catch (error) {
    return false;
  }
};

export const fileToBlob = async file => {
  if (isHeicFile(file)) {
    return convertHeicToJpeg(file);
  }
  return file;
};

export default {};
